import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class ApHtmlTextContentService {

  public getTextContentLength(htmlText: string | null, trimType: TrimTypes | null = null): number {
    if (!htmlText) return 0;

    let textContent = htmlText
      .replace(/<.*?>/g, '')
      .replace(/(\r\n|\n|\r)/gm, ' ');

    if (trimType) {
      textContent = this.getTrimmedText(textContent, trimType);
    }

    return textContent.length;
  }

  public removeNewLineCharacters(htmlText: string | null): string {
    if (!htmlText) return '';

    const textContent = htmlText.replace(/(\n|\r)/gm, '');
    return textContent;
  }

  public getTextContent(htmlText: string | null, trimType: TrimTypes | null = null): string {
    if (!htmlText) return '';

    let textContent = htmlText
      .replace(/<.*?>/g, '')
      .replace(/(\r\n|\n|\r)/gm, ' ');

    if (trimType) {
      textContent = this.getTrimmedText(textContent, trimType);
    }

    return textContent;
  }

  public getTextContentWithCompressedWhitespace(htmlText: string| null, trimType: TrimTypes | null = null): string {
    if (!htmlText) return '';

    let textContent = htmlText
      .replace(/<.*?>/g, '')
      .replace(/(\r\n|\n|\r)/gm, ' ')
      .replace(/\s+/g, ' ');

    if (trimType) {
      textContent = this.getTrimmedText(textContent, trimType);
    }

    return textContent;
  }

  private getTrimmedText(text: string, trimType: TrimTypes): string {
    if (trimType) {
      switch (trimType) {
        case TrimTypes.LeadingSpaces:
          return text.trimStart();
        case TrimTypes.TrailingSpaces:
          return text.trimEnd();
        case TrimTypes.LeadingAndTrailingSpaces:
          return text.trim();
      }
    }
    return text;
  }
}

export enum TrimTypes {
  LeadingSpaces = 'LeadingSpaces',
  TrailingSpaces = 'TrailingSpaces',
  LeadingAndTrailingSpaces = 'LeadingAndTrailingSpaces',
}
